module.exports = __webpack_public_path__ + "fonts/proximanova-regular-webfont.16f17752.ttf";